import axios from 'axios';
import { environment as env, environment } from '../../environments/environment';

import { api as apiExports } from '../api';
const {
    Interceptor: api,
    routes
} = apiExports;
export const get_employee_certificates = async (payload, headers) => {
    const { id } = payload;
    return await api.get(
        routes.employee.get_employee_all_certificates.concat(id),
        payload,
        headers
    );
};
export const get_AuditView = async (payload, headers) => {
    const { id } = payload;
    return await api.get(
        routes.employee.get_Audit_view.concat(id),
        payload,
        headers
    );
};

export const AuditViewGet = async (payload, headers) => {
    const { id } = payload;

    // Ensure id is converted to string
    const url = routes.employee.get_Audit_view.concat(id.toString());

    return await api.get(url, payload, headers);
};

export const downlaod_pdf = async (payload, headers = {}) => {
    const { id, filters = {} } = payload;

    try {
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };

        const response = await axios.post(
            env.apiPath.concat(routes.employee.downlaod_auditPdf.concat(id)),
            payload, // Specify response type as 'arraybuffer' for binary data,
            { responseType: 'blob', headers },

        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }
};
export const add_employee_certificate = async (payload, headers) => {
    return await api.post(
        routes.employee.add_certificate,
        payload,
        headers
    );
}

export const update_employee_certificate = async (payload, headers) => {
    const { id } = payload;
    return await api.put(
        routes.employee.update_certificate.concat(id),
        payload,
        headers
    );
}

export const add_employee_hardware = async (payload, headers) => {
    const { id } = payload;
    return await api.post(
        routes.employee.add_hardware.concat(id),
        payload,
        headers
    );
}


export const Edit_employee_hardware = async (payload, headers) => {
    const { id } = payload;

    return await api.put(
        routes.employee.EditHardware.concat(id),
        payload,
        headers
    );
}

export const onUpdateSSN = async (payload, headers) => {
    const { id } = payload;
    return await api.put(
        routes.employee.update_ssn.concat(id),
        { ssn: payload.ssn },
        headers
    );
}

export const get_employee_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.get_employee_list,
        payload,
        headers
    );
};
export const get_employee_listing_not_Terminated = async (payload, headers) => {
    return await api.get(
        routes.employee.get_employee_listing_not_Terminated,
        payload,
        headers
    );
};
export const get_employee_AssignTo_listing_not_Terminated = async (payload, headers) => {
    return await api.get(
        routes.employee.get_employee_AssignTo_listing_not_Terminated,
        payload,
        headers
    );
};
export const AssignTo = async (payload, headers) => {
    return await api.get(
        routes.employee.AssignTo,
        payload,
        headers
    );
};
export const ContractorTo = async (payload, headers) => {
    return await api.get(
        routes.employee.ContractorTo,
        payload,
        headers
    );
};

export const get_crew_user_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.get_crew_user_list,
        payload,
        headers
    );
};

export const get_Template = async (payload, headers) => {
    return await api.get(
        routes.employee.get_Template,
        payload,
        headers
    );
};

export const get_assisting_member_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.get_assisting_member_list,
        payload,
        headers
    );
};

export const get_department_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.get_department_list,
        payload,
        headers
    );
};

export const get_subDepartment_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.all_subdepartments,
        payload,
        headers
    );
};


export const getForemanData = async (payload, headers) => {
    return await api.get(
        routes.employee.getForeman,
        payload,
        headers
    );
};


export const get_ticket_type_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.get_ticket_type_list,
        payload,
        headers
    );
};

export const getAllPayroll = async (payload, headers) => {
    return await api.get(
        routes.employee.getAllPayroll,
        payload,
        headers
    );
};
export const deletePayrollUser = async (id, payload, headers) => {
    return await api.put(
        routes.employee.getAllPayroll + `/${id}`,
        payload,
        headers
    );
};

export const createPayroll = async (payload, headers) => {
    return await api.post(
        routes.employee.createPayroll,
        payload,
        headers
    );
};

export const get_ticket_category_by_type = async (payload, headers) => {
    const { id } = payload;
    return await api.get(
        routes.employee.get_ticket_category_by_type.concat(id),
        payload,
        headers
    );
};


export const create_ticket = async (payload, headers) => {
    return await api.post(
        routes.employee.create_ticket,
        payload,
        headers
    );
};


export const department_contact_list = async (payload, headers) => {
    const { id } = payload;

    return await api.get(
        routes.employee.department_contact_list.concat(id),
        payload,
        headers
    );
};

export const get_job_category_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.job_category_list,
        payload,
        headers
    );
};

export const get_site_listing = async (payload, headers) => {
    return await api.get(
        routes.employee.site_list,
        payload,
        headers
    );
};

export const get_locomotive_equip = async (payload, headers) => {
    return await api.get(
        routes.employee.locomotive_equip,
        payload,
        headers
    );
};
export const get_locomotive_equip_Status = async (payload, headers) => {
    return await api.get(
        routes.employee.locomotive_equipStatus,
        payload,
        headers
    );
};

export const get_test_event_listing = async (payload, headers) => {
    const { params } = payload
    return await api.get(
        routes.employee.get_test_event_list.concat(params),
        payload,
        headers
    );
};
export const get_test_event_listing_dashboard = async (payload, headers) => {
    const { params } = payload
    return await api.get(
        routes.employee.get_test_event_list_dashboard.concat(params),
        payload,
        headers
    );
};



export const create_test_event = async (payload, headers) => {
    return await api.post(
        routes.employee.create_test_event,
        payload,
        headers
    );
};

export const get_test_event_by_id = async (payload, headers) => {
    const { id } = payload;
    return await api.get(
        routes.employee.get_test_event_by_id.concat(id),
        payload,
        headers
    );
};

export const rules_listing = async (payload, headers) => {
    const { params } = payload
    return await api.get(
        routes.employee.get_rules_list.concat(params),
        payload,
        headers
    );
};

export const add_rule_event = async (payload, headers) => {
    return await api.post(
        routes.employee.create_test_event_rule,
        payload,
        headers
    );
};


export const view_rule_event = async (payload, headers) => {
    const { id } = payload;
    return await api.get(
        routes.employee.view_test_event_rule.concat(id),
        payload,
        headers
    );

};


export const view_rule_event_dashboard = async (payload, headers) => {
    const { id } = payload;
    return await api.get(
        routes.employee.view_test_event_rule_dashboard.concat(id),
        payload,
        headers
    );

};

export const get_checkride_table = async ({ params }, headers) => {
    return await api.get(
        routes.checkride.checkride_table.concat(params),
        headers
    );
};

export const get_checkride_table_by_Id = async (payload, headers) => {
    const { id } = payload;
    return await api.get(
        routes.checkride.checkride_table_id.concat(id),
        payload,
        headers
    );
};

export const DownloadPdfWorkOrder = async (payload, headers = {}) => {
    const { id } = payload;

    try {
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };

        const response = await axios.get(
            env.apiPath.concat(routes.Locomotive.DownloadPdfLocomotive.concat(id)),
            { responseType: 'blob', headers },
            payload, // Specify response type as 'arraybuffer' for binary data

        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }
};

export const DownloadExportCheckRide = async (payload, headers = {}) => {
    const { id } = payload;

    try {
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };

        const response = await axios.get(
            env.apiPath.concat(routes.checkride.DownloadExportCheckRide.concat(id)),
            { responseType: 'blob', headers },
            payload, // Specify response type as 'arraybuffer' for binary data

        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }
};

export const DownloadMaintenanceHistory = async (payload, headers = {}) => {
    const { id, filters = {} } = payload;

    try {
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };

        const response = await axios.get(
            env.apiPath.concat(routes.checkride.DownloadMaintenanceHistory.concat(id)) + `?search=${filters?.search}&toggle=${filters?.toggle}`,
            { responseType: 'blob', headers },
            payload, // Specify response type as 'arraybuffer' for binary data

        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }
};
export const DownloadDatasheet = async (payload, headers = {}) => {
    const { idDatasheet } = payload;

    try {
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        headers = {
            ...headers,
            Authorization: AuthorizationExtracted
        };

        const response = await axios.get(
            env.apiPath.concat(routes.checkride.DownloadDatasheet.concat(idDatasheet)),
            { responseType: 'blob', headers },
            payload, // Specify response type as 'arraybuffer' for binary data

        );

        return response.data;
    } catch (error) {
        console.error('Error fetching PDF content:', error);
        throw error;
    }
};


export const checkride_table = async (payload, headers) => {
    return await api.get(
        routes.checkride.checkride_table,
        payload,
        headers
    );
};

export const AuditTableApi = async (query, payload, headers) => {
    const queryString = new URLSearchParams({ Templates: query }).toString();

    return await api.get(
        `${routes.employee.AuditTable}?${queryString}`, // Append query string to the URL
        { params: payload, headers }
    );
};


export const getAllData = async (filters) => {
    const queryParams = new URLSearchParams(filters).toString();
    return await api.get(
        routes.employee.getalltable + `?${queryParams}`,
    );
};
export const getAllDataParams = async (evaluatorId) => {
    try {
        console.log('Evaluator ID:', evaluatorId);  // Debugging

        // Concatenate the evaluatorId into the URL
        const url = routes.employee.getalltable.concat(`?EvaluatorId=${evaluatorId}`);

        // Perform the GET request using the concatenated URL
        const response = await api.get(url);

        return response;
    } catch (error) {
        console.error('Error fetching data in getAllDataParams:', error?.response?.data || error.message);
        throw error;
    }
};



// Define the function to fetch data with filter parameters
export const getAllDataParamsColumns = async (filtersData) => {
    try {
        // Log filters for debugging

        // Assuming routes.employee.getalltable is the base URL or endpoint
        let url = routes.employee.getalltable;  // Base API URL
        const queryParams = new URLSearchParams(filtersData).toString();
        // Create query parameters string from the object
        // Perform the GET request with filters passed as query parameters
        const response = await api.get(url + `?${queryParams}`);

        // Return the response from the API
        return response?.data;
    } catch (error) {
        // Log any errors
        console.error('Error fetching data in getAllDataParams:', error?.response?.data || error.message);
        throw error;  // Rethrow the error
    }
}














export const sendAuditData = async (payload, headers) => {
    return await api.post(
        routes.employee.sendAudit,
        payload,
        headers
    );
};

export const TableWoDelete = async (id, payload, headers) => {
    return await api.post(
        routes.Locomotive.TableWoDelete + `/${id}`,
        payload,
        headers
    );
};
export const TableDeleteDataLocomotive = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.TableWoDelete,
        payload,
        headers
    );
};
export const TableDataDays = async (id, payload, headers) => {

    return await api.post(
        routes.Locomotive.TableDataDays + `/${id}`,
        payload,
        headers
    );
};
export const TableDataDaysLocomotive = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.TableDataDays,
        payload,
        headers
    );
};
export const TableDataDaysExport = async (id, payload, headers) => {

    return await api.post(
        routes.Locomotive.TableDataFilterSheet + `/${id}`,
        payload,
        headers
    );
};
export const TableDataDaysExportLocomotive = async (payload, headers) => {
    return await api.post(
        routes.Locomotive.TableDataFilterSheet,
        payload,
        headers
    );
};

export const checkride_table_submit = async (payload, headers) => {
    return await api.post(
        routes.checkride.checkride_table,
        payload,
        headers
    );
};

export const logout = async (payload, headers) => {
    const { id } = payload;

    return await api.post(
        routes.employee.employee_logout.concat(id),
        headers
    );
}


export const Applicantlogout = async (payload, headers) => {
    const { id } = payload;

    return await api.post(
        routes.employee.Applicant_logout.concat(id),
        headers
    );
}

export const get_safety_testing_event_type = async (id, headers) => {

    return await api.get(
        routes?.testEvent?.event_type + id,
        headers
    );
}
export const get_RailRoad = async (id, headers) => {

    return await api.get(
        routes?.testEvent?.AssignedTo + id,
        headers
    );
}

export const get_safety_testing_job_listing = async (headers) => {



    return await api.get(
        routes?.testEvent?.job_id,

    );
}

export const get_hardware_assignments = async (params) => {
    if (params) return await api.get(routes?.hardware.data.concat(params))
    return await api.get(routes?.hardware?.data)
}

export const get_employee_check_ride_fields = async () => {
    return await api.get(routes?.employee?.checkride_fields)
}

export const on_edit_hardware = async (hardwareId, body) => {
    return await api.put(routes?.hardware.edit.concat(hardwareId), body)
}
export const updateDOB = async (employeeId, body) => {
    return await api.put(routes?.employee.employee_Dob.concat(employeeId), body)
}
export const updateHardwareRow = async (id, body) => {
    return await api.put(routes?.employee.updateHardwareRow.concat(id), body)
}